import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CreditCard, ShieldCheck, PackageCheck } from "lucide-react";
import { PurchaseTotals } from "./PurchaseTotals";
import { InstallmentsEditor } from "./InstallmentsEditor";
import { WarrantySection } from "./WarrantySection";
import { Collapsible } from "./Collapsible";
import { calcTotals } from "./calcTotals";

// حزمة سفلية: إجماليات + ملاحظات + دفعات (طيّ) + كفالة (طيّ) + شريط فحص المخزون.
export const BuilderTotalsPack = ({ lines, head, onChange, plan, onPlan, currency = "AED" }) => {
  const { t } = useTranslation();
  const totals = useMemo(() => calcTotals(lines, head),
    [lines, head.discount_percent, head.discount_amount, head.tax_percent]);
  const openInst = head.payment_terms_kind === "installments";
  return (
    <div className="grid gap-4">
      <PurchaseTotals totals={totals} head={head} onChange={onChange} currency={currency} />
      <label className="grid gap-1.5">
        <span className="text-[11px] font-bold text-muted-foreground">{t("purchases.notes")}</span>
        <textarea data-testid="purchase-notes" value={head.notes || ""}
                  onChange={(e) => onChange({ ...head, notes: e.target.value })}
                  placeholder={t("purchases.notesPh")}
                  className="min-h-[80px] rounded-2xl bg-background px-4 py-3 text-sm shadow-neu-in outline-none focus:ring-2 focus:ring-ring" />
      </label>
      <Collapsible icon={CreditCard} testid="payment-schedule" defaultOpen={openInst}
                   title={t("purchases.paymentScheduleTitle")}>
        <InstallmentsEditor rows={plan} onChange={onPlan} head={head} onHead={onChange}
                            grand={totals.grand} currency={currency} />
      </Collapsible>
      <Collapsible icon={ShieldCheck} testid="warranty" title={t("purchases.warranty.title")}>
        <WarrantySection head={head} onChange={onChange} />
      </Collapsible>
      <div data-testid="stock-check-hint"
           className="flex items-start gap-2 rounded-2xl bg-blue-50 p-3 text-[11px] font-medium text-blue-900 dark:bg-blue-900/20 dark:text-blue-100">
        <PackageCheck className="h-4 w-4 shrink-0" />
        <span>{t("purchases.stockCheckHint")}</span>
      </div>
    </div>
  );
};
